var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubmit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65409 3.17002L1.87065 8.95345C1.71779 9.10632 1.53944 9.18275 1.33562 9.18275C1.1318 9.18275 0.953455 9.10632 0.800588 8.95345C0.647722 8.80059 0.571289 8.62224 0.571289 8.41842C0.571289 8.2146 0.647722 8.03626 0.800588 7.88339L7.88339 0.800588C7.96832 0.715663 8.05324 0.656215 8.13817 0.622244C8.22309 0.588274 8.31651 0.571289 8.41842 0.571289C8.52033 0.571289 8.61375 0.588274 8.69868 0.622244C8.7836 0.656215 8.86853 0.715663 8.95345 0.800588L16.0363 7.88339C16.1891 8.03626 16.2656 8.2146 16.2656 8.41842C16.2656 8.62224 16.1891 8.80059 16.0363 8.95345C15.8834 9.10632 15.705 9.18275 15.5012 9.18275C15.2974 9.18275 15.1191 9.10632 14.9662 8.95345L9.18275 3.17002V15.807C9.18275 16.0278 9.11057 16.2104 8.96619 16.3547C8.82182 16.4991 8.63923 16.5713 8.41842 16.5713C8.19762 16.5713 8.01503 16.4991 7.87065 16.3547C7.72628 16.2104 7.65409 16.0278 7.65409 15.807V3.17002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmit);
export default __webpack_public_path__ + "static/media/submit.772f397ff1e153de9c41e553d6625983.svg";
export { ForwardRef as ReactComponent };